import React, { useContext, useEffect, useState } from 'react'
import { FaCameraRetro, FaLayerGroup } from 'react-icons/fa'
import { IoIosImages } from 'react-icons/io'
import { MdModeEditOutline } from 'react-icons/md'
import { EditorContext } from '../../../../components/CanvasEditor/Context/EditorProvider'
import AddProps from './EditOptions/AddProps'
import AddText from './EditOptions/AddText'
import List from './EditOptions/Layers/List'
import UploadPhoto from './EditOptions/UploadPhoto'

const Sidebar = () => {


  const { selectedObjects } = useContext(EditorContext)

  const [activeTab, setActiveTab] = useState('photo')

  useEffect(()=> {
    if (selectedObjects.length > 0) {
      if (selectedObjects[0].type === 'text') {
        setActiveTab('text')
      }
    }
  }, [selectedObjects])

  return (
    <div className='menu-panel'>
      <div className='menu-panel-header'>
        <ul>
          <li className={activeTab === 'photo' ? 'active' : ''} onClick={e=> setActiveTab('photo')}>
            <span>
              <FaCameraRetro />
            </span>
          </li>
          <li className={activeTab === 'text' ? 'active' : ''} onClick={e=> setActiveTab('text')}>
            <span>
              <MdModeEditOutline />
            </span>
          </li>
          <li className={activeTab === 'layers' ? 'active' : ''} onClick={e=> setActiveTab('layers')}>
            <span>
              <FaLayerGroup />
            </span>
          </li>
          <li className={activeTab === 'props' ? 'active' : ''} onClick={e=> setActiveTab('props')}>
            <span>
              <IoIosImages />
            </span>
          </li>
        </ul>
      </div>
      
      {
        activeTab === 'photo' &&
        <UploadPhoto />
      }

      {
        activeTab === 'text' &&
        <AddText />
      }
      {
        activeTab === 'layers' &&
        <List />
      }
      {
        activeTab === 'props' &&
        <AddProps />
      }
    </div>
  )
}

export default Sidebar